import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'

import Box from '@material-ui/core/Box'
import Button from '@material-ui/core/Button'
import makeStyles from '@material-ui/core/styles/makeStyles'

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    height: '100vh',
    width: '100%',
  },
  toolbar: {
    display: 'flex',
    justifyContent: 'flex-end',
    padding: '8px 16px',
    backgroundColor: '#f5f5f5',
    borderBottom: '1px solid #ddd',
  },
  embed: {
    flex: 1,
    border: 'none',
    width: '100%',
    height: '100%',
  },
}))

const ViewerDocument = ({ documentBase64, fileName }) => {
  const classes = useStyles()
  const [blobUrl, setBlobUrl] = useState(null)

  useEffect(() => {
    const byteChars = atob(documentBase64)
    const byteNums = Array.from(byteChars, (c) => c.charCodeAt(0))
    const blob = new Blob([new Uint8Array(byteNums)], { type: 'application/pdf' })
    const url = URL.createObjectURL(blob)
    setBlobUrl(url)

    return () => URL.revokeObjectURL(url)
  }, [documentBase64])

  if (!blobUrl) return <Box>Carregando...</Box>

  return (
    <Box className={classes.root}>
      <Box className={classes.toolbar}>
        <Button
          variant="contained"
          color="primary"
          component="a"
          href={blobUrl}
          download={fileName}
        >
          Baixar PDF
        </Button>
      </Box>
      <embed
        src={blobUrl}
        type="application/pdf"
        className={classes.embed}
      />
    </Box>
  )
}

ViewerDocument.propTypes = {
  documentBase64: PropTypes.string.isRequired,
  fileName: PropTypes.string,
}

ViewerDocument.defaultProps = {
  fileName: 'documento.pdf',
}

export default ViewerDocument
